// extracted by mini-css-extract-plugin
export default {"bodyText":"InviteUsersForm-bodyText-c1e41556efc24ac7aefa2635d56f2ebf"};